export const site = {
  name: "Travis Johnson",
  title: "Travis Johnson | Technology, Business and Digital Product Builder",
  description:
    "Travis Johnson is a technology and business operator in Oceanside, California, building digital products, ecommerce systems, healthcare platforms, media workflows, and growing businesses.",
  location: "Oceanside, California",
  linkedin: "https://www.linkedin.com/in/travisjohnson85/",
  email: "tjohn1029@gmail.com",
};
